<div class="container-fluid mt-4">
  <form class="form-horizontal" (ngSubmit)="submit()">
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-header">
            <h3>Achievement</h3>
          </div>
          <div class="card-body">
            <div *ngIf="!achievement">Loading...</div>

            <!-- Internal ID -->
            <ng-container *ngIf="achievement">
              <div class="row my-2">
                <div class="form-group col-3">
                  <span>Internal Name</span>
                </div>
                <div class="form-group col-9">
                  <input
                    name="name"
                    class="form-control"
                    autofocus="true"
                    autocomplete="off"
                    type="text"
                    [ngModel]="achievement.name"
                    [placeholder]="achievement.name"
                    (ngModelChange)="achievement.name = $event.trim();"
                    required
                  />
                </div>
              </div>

              <!-- Display Name -->
              <div class="row my-2">
                <div class="form-group col-3">
                  <span>Title{{languageHint}}</span>
                </div>
                <div class="form-group col-9">
                  <input
                    name="title"
                    class="form-control"
                    autofocus="true"
                    autocomplete="off"
                    type="text"
                    [ngModel]="title"
                    [placeholder]="title ?? achievement.name"
                    (ngModelChange)="title = $event.trim();"
                    required
                  />
                </div>
              </div>

              <!-- Description (locked) -->
              <div class="row my-2">
                <div class="form-group col-3">
                  <span>Description while locked{{languageHint}}</span>
                </div>
                <div class="form-group col-9">
                  <input
                    name="description-locked"
                    class="form-control"
                    autofocus="true"
                    autocomplete="off"
                    type="text"
                    [ngModel]="descriptionLocked"
                    [placeholder]="descriptionLocked ?? ''"
                    (ngModelChange)="descriptionLocked = $event.trim();"
                    required
                  />
                </div>
              </div>

              <!-- Description (achieved) -->
              <div class="row my-2">
                <div class="form-group col-3">
                  <span>Description when achieved{{languageHint}}</span>
                </div>
                <div class="form-group col-9">
                  <input
                    name="description-achieved"
                    class="form-control"
                    autofocus="true"
                    autocomplete="off"
                    type="text"
                    [ngModel]="descriptionAchieved"
                    [placeholder]="descriptionAchieved ?? ''"
                    (ngModelChange)="descriptionAchieved = $event.trim();"
                    required
                  />
                </div>
              </div>

              <!-- Unlock Value & Related Stat -->
              <div class="row my-2">
                <div class="form-group col-3">
                  <span>Requirement</span>
                </div>
                <div class="form-group col-6">
                  <select class="form-control form-select" name="requirement-type" [(ngModel)]="statOptionIndex" required>
                    <option *ngFor="let s of statOptions; let i = index" [value]="i">{{ s.name }}</option>
                  </select>
                </div>
                <div class="form-group col-3">
                  <input
                    name="requirement-amount"
                    class="form-control"
                    autofocus="true"
                    autocomplete="off"
                    type="number"
                    [(ngModel)]="achievement.unlock_value"
                    required
                  />
                </div>
              </div>
              <div class="row my-2" *ngIf="statOption.path && path">
                <div class="form-group col-3">
                  <span>Path</span>
                </div>
                <div class="form-group col-9">
                  <app-nested-path-selector
                    [tree]="tree"
                    [(element)]="path"
                    [maxDepth]="maxDepth"
                    [readonly]="loading"
                    (elementChange)="stat.selector = $event.node?.uuid;"
                  >
                  </app-nested-path-selector>
                </div>
              </div>

              <!-- Score -->
              <div class="row my-2">
                <div class="form-group col-3 d-flex flex-row">
                  <label class="col-form-label" for="score-switch">Score Reward</label>
                  <div class="form-check form-switch m-2">
                    <input
                      class="form-check-input"
                      type="checkbox"
                      role="switch"
                      id="score-switch"
                      [checked]="scoreEnabled"
                      (change)="scoreEnabled = !scoreEnabled"
                    />
                  </div>
                </div>
                <div *ngIf="scoreEnabled" class="form-group col-9">
                  <div class="form-group col-3">
                    <input
                      name="score-value"
                      class="form-control"
                      autofocus="true"
                      autocomplete="off"
                      type="number"
                      [(ngModel)]="scoreValue"
                    />
                  </div>
                </div>
              </div>

              <!-- Notifications -->
              <div class="row my-2">
                <div class="form-group col-3 d-flex flex-row">
                  <label class="col-form-label" for="notification-switch">Notification</label>
                  <div class="form-check form-switch m-2">
                    <input
                      class="form-check-input"
                      type="checkbox"
                      role="switch"
                      id="notification-switch"
                      [checked]="notificationEnabled"
                      (change)="notificationEnabled = !notificationEnabled"
                    />
                  </div>
                </div>
                <div *ngIf="notificationEnabled" class="form-group col-9">
                  <div class="row">
                    <div class="form-group col-2">
                      <span>Title{{languageHint}}</span>
                    </div>
                    <div class="form-group col-10">
                      <input
                        name="notification-title"
                        class="form-control"
                        autofocus="true"
                        autocomplete="off"
                        type="text"
                        [ngModel]="notificationTitle"
                        (ngModelChange)="notificationTitle = $event.trim();"
                        required
                      />
                    </div>
                  </div>
                  <div class="row mt-2">
                    <div class="form-group col-2">
                      <span>Message{{languageHint}}</span>
                    </div>
                    <div class="form-group col-10">
                      <input
                        name="notification-message"
                        class="form-control"
                        autofocus="true"
                        autocomplete="off"
                        type="text"
                        [ngModel]="notificationMessage"
                        (ngModelChange)="notificationMessage = $event.trim();"
                        required
                      />
                    </div>
                  </div>
                </div>
              </div>

              <!-- Time Limit / Events -->
              <div class="row my-2">
                <div class="form-group col-3 d-flex flex-row">
                  <label class="col-form-label" for="event-switch">Event</label>
                  <div class="form-check form-switch m-2">
                    <input
                      class="form-check-input"
                      type="checkbox"
                      role="switch"
                      id="event-switch"
                      [checked]="event"
                      (change)="event = !event"
                    />
                  </div>
                </div>
                <div *ngIf="event" class="form-group col-9">
                  <div class="row">
                    <div class="form-group col-2">
                      <span>Start at</span>
                    </div>
                    <div class="form-group col-5">
                      <input
                        class="form-control datetimepicker"
                        [(ngModel)]="eventStartDate"
                        (click)="startDate.toggle()"
                        autocomplete="off"
                        placeholder="yyyy-mm-dd"
                        name="startDate"
                        #startDate="ngbDatepicker"
                        ngbDatepicker
                        required
                      />
                    </div>
                    <div class="form-group col-auto">
                      <ngb-timepicker
                        name="startTime"
                        [(ngModel)]="eventStartTime"
                        [spinners]="false"
                        autocomplete="off"
                        required
                      ></ngb-timepicker>
                    </div>
                    <div class="col-auto">UTC</div>
                  </div>
                  <div class="row mt-2">
                    <div class="form-group col-2">
                      <span>End at</span>
                    </div>
                    <div class="form-group col-5">
                      <input
                        class="form-control datetimepicker"
                        [(ngModel)]="eventEndDate"
                        (click)="endDate.toggle()"
                        autocomplete="off"
                        placeholder="yyyy-mm-dd"
                        name="endDate"
                        #endDate="ngbDatepicker"
                        ngbDatepicker
                        required
                      />
                    </div>
                    <div class="form-group col-auto">
                      <ngb-timepicker
                        name="endTime"
                        [(ngModel)]="eventEndTime"
                        [spinners]="false"
                        autocomplete="off"
                        required
                      ></ngb-timepicker>
                    </div>
                    <div class="col-auto">UTC</div>
                  </div>
                </div>
              </div>

              <!-- Errors -->
              <div *ngIf="error" class="mb-2 mt-4" style="text-align: right">
                <span class="small text-danger">{{ error }}</span>
              </div>

              <!-- Buttons -->
              <div class="btn-group float-end my-2">
                <button class="btn btn-light" type="button" [disabled]="loading" (click)="cancel()">
                  <fa-icon icon="times-circle" size="md"></fa-icon>
                  Cancel
                </button>
                <button [disabled]="error" type="submit" class="btn btn-primary" [disabled]="loading || error || selectorMissing">
                  <fa-icon icon="sync-alt" size="md"></fa-icon>
                  {{ achievement.uuid == null ? 'Create' : 'Update' }}
                </button>
              </div>
            </ng-container>
          </div>
        </div>
      </div>
    </div>
  </form>
</div>
